import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { BaseSummaryControlDirective } from '../base/base-summary-control';
import { Vraagtype } from '@models/claims';
import { VraagboomUploadResultaat } from '@models/vragenboom';
import { ImageHelper } from '../../../utils/helpers/image-helper';

@Component({
  selector: 'app-upload-summary',
  templateUrl: './upload-summary.component.html',
  styleUrls: ['./upload-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UploadSummaryComponent extends BaseSummaryControlDirective<VraagboomUploadResultaat> implements OnInit {
  uploadtype: string;
  isFilesUpload = false;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.antwoordResultaat.vraag.vraagtype === Vraagtype.Upload) {
      this.isFilesUpload = true;
      this.uploadtype = 'bestanden';
    } else {
      this.uploadtype = "foto's";
    }
  }

  isFileImage(filename: string): boolean {
    return ImageHelper.isFileImage(filename);
  }
}
